// Directiva `v-click-outside`: invoca el handler bindeado cuando un click
// del document.body cae fuera del elemento (y sus descendientes). Útil para
// cerrar dropdowns/poppers cuando el componente vive en un portal o detrás
// de un overlay y no podemos delegar al cierre nativo de Buefy.
//
// Uso:
//
//     import clickOutside from "@/directives/clickOutside";
//     export default {
//         directives: { clickOutside },
//         methods: { close() { ... } },
//     };
//
//     <div v-click-outside="close">...</div>
//
// Forward-compat con Vue 3: la directiva expone los hooks de Vue 2 (`bind`,
// `unbind`) y sus equivalentes Vue 3 (`beforeMount`, `unmounted`). El
// `@vue/compat` migration build acepta ambos sets durante la transición, y
// el codemod del paso final solo necesita borrar las versiones legacy. El
// handler se guarda en un WeakMap (no en `el._xxx`) porque Vue 3 con Proxy
// no expone los privates por prefijo, y un WeakMap evita filtraciones si
// el elemento se desmonta entre bind y unbind.

const HANDLERS = new WeakMap();

function bindHandler(el, binding) {
    const handler = (event) => {
        if (el !== event.target && !el.contains(event.target)) {
            binding.value(event);
        }
    };
    HANDLERS.set(el, handler);
    document.addEventListener("click", handler);
}

function unbindHandler(el) {
    const handler = HANDLERS.get(el);
    if (handler) {
        document.removeEventListener("click", handler);
        HANDLERS.delete(el);
    }
}

export default {
    bind: bindHandler,
    unbind: unbindHandler,
    beforeMount: bindHandler,
    unmounted: unbindHandler,
};
